import { Variant } from '@mui/material/styles/createTypography'
import { AvatarSize } from 'components/core/avatar/AvatarSizes'
import { AppUserDisplayName } from 'components/pages/app/users/app-user-display-name'
import { UserDisplayName } from 'components/pages/user/user-display-name'
import { TaskValue } from 'lib/actions/task'
import { FC } from 'react'

type TaskUserDisplayNameProps = {
    task: TaskValue
    avatarSize?: AvatarSize
    readOnly?: boolean
    displayNameVariant?: Variant
    includeDetails?: boolean
    showTooltip?: boolean
    margin?: boolean
    showUserStatus?: boolean
}

export const TaskUserDisplayName: FC<TaskUserDisplayNameProps> = ({
    task,
    avatarSize,
    readOnly,
    displayNameVariant,
    includeDetails,
    showTooltip,
    margin,
    showUserStatus,
}) => {
    return task.appUser ? (
        <AppUserDisplayName
            appUser={task.appUser}
            showTooltip={showTooltip}
            avatarSize={avatarSize}
            readOnly={readOnly}
            displayNameVariant={displayNameVariant}
            margin={margin}
            includeDetails={includeDetails}
            showDeletedDisabledStatus={showUserStatus}
        />
    ) : (
        <UserDisplayName
            user={task.user}
            showTooltip={showTooltip}
            avatarSize={avatarSize}
            readOnly={readOnly}
            displayNameVariant={displayNameVariant}
            margin={margin}
            includeDetails={includeDetails}
            showUserStatus={showUserStatus}
        />
    )
}
